import type { ToggleWithLabelsAtmProps } from "@onestore/hel/dist/components/atoms/ToggleWithLabelsAtm"
import _t from "@core/i18n"
import { PriceType } from "@core/types"
import { usePriceTypeContext } from "~/context/PriceTypeContext"
import { productBoxClickEvent } from "~/lib/analytics"

export function useTogglePriceType(): ToggleWithLabelsAtmProps {
  const { currentPriceType, isNettoPriceType, setPriceType } =
    usePriceTypeContext()

  const handleToggleSwitch = () => {
    let eventPriceType = PriceType.GROSS

    if (currentPriceType === PriceType.NETTO) {
      setPriceType(PriceType.GROSS)
    } else {
      setPriceType(PriceType.NETTO)
      eventPriceType = PriceType.NETTO
    }

    productBoxClickEvent({
      productbox_type: "toggle",
      productbox_option: eventPriceType,
    })
  }

  return {
    id: "toggle-price-type",
    values: [_t("prices.netto"), _t("prices.gross")],
    activeIndex: isNettoPriceType ? 0 : 1,
    onClick: handleToggleSwitch,
  }
}
